module.exports = __webpack_public_path__ + "73ab69f7bbb6c0db350dbf7f878e1cb6.svg";